<template lang="pug">
div
  .background-container(:class="[$store.getters.isLoggedIn ? 'logged-in' : 'before-login']")
    leftBar
    .right-wrapper
      topBar  
      router-view
        rightBar
      footerInfo
    .d-flex.login-wrap(v-if="!$store.getters.isLoggedIn" :class="{'justify-content-center' : smallScreen}")
      .col-6.text-center
        .btn-login(data-dismiss='modal' data-toggle='modal' data-target='#modal-login') {{$t('ui.login')}}
    .overlay
  promoModal
  template(v-if="!$store.getters.isLoggedIn")
    login
  template(v-else)
    changePw
    //- referral
    profile
    bankDetail
    deposit
    withdrawal
    //- settlement
</template>
<script>
import login from "@/component/_login.vue"
import changePw from "@/component/_changePw.vue"
// import referral from "@/component/_referral.vue"
import profile from "@/component/_userProfile.vue"
import bankDetail from "@/component/_bankProfile.vue"
// import settlement from "@/component/statement/_settlementHistory.vue"
import deposit from "@/component/_deposit.vue"
import withdrawal from "@/component/_withdrawal.vue"
import topBar from '@/views/default/_topBar.vue'
import leftBar from '@/views/default/_leftBar.vue'
import rightBar from '@/views/default/_rightBar.vue'
import promoModal from '@/component/_promoModal.vue'
import footerInfo from '@/views/default/_footer.vue'
export default{
  components:{
    login,
    changePw,
    // referral,
    profile,
    bankDetail,
    deposit,
    withdrawal,
    // settlement,
    topBar,
    promoModal,
    leftBar,
    rightBar,
    footerInfo
  },
  data(){
    return{
      smallScreen: false
    }
  },
  computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
	},
  mounted(){
    var vm = this
    this.toggleNav()
    $(window).resize(function () {
      vm.toggleNav()
    });
  },
  methods:{
    toggleNav(){
      var vm = this
      if ($(window).width() < 992) {
        vm.smallScreen = true
      }else{
        vm.smallScreen = false
      }
    },
  }
}

</script>
<style lang="scss" scoped>

</style>